import { FilterSetPane } from 'components/Filter';
import { isEqual } from 'lodash';
import React, { useRef, useCallback } from 'react';
import { useFiltersStore } from 'store/useFiltersStore';
import usePropertiesStore from 'store/usePropertiesStore';
import { DEFAULT_FILTER } from 'util/Constants';
import { getFilterCount } from 'util/Funcs';
import { FilterType } from 'util/Types';
import PublicMobileFilterSection from './PublicMobileFilterSection';

interface FilterSetPaneHandles {
    getFilter: () => FilterType;
    clearFilter: () => void;
}

const PublicFilterPanel: React.FC = () => {
    const filterRef = useRef<FilterSetPaneHandles>();
    const { currentFilter, setCurrentFilter } = useFiltersStore();
    const { setCurrentPage } = usePropertiesStore();

    const onClearClicked = useCallback(() => {
        // Clear all filters for public users
        setCurrentFilter(DEFAULT_FILTER);
        filterRef!.current!.clearFilter();
    }, [setCurrentFilter]);

    const handleFiltersChange = useCallback(
        (filter: FilterType) => {
            // For public users, just set the filter directly
            setCurrentFilter(filter);
            if (!isEqual(filter, currentFilter)) {
                setCurrentPage(0);
            }
        },
        [currentFilter, setCurrentFilter, setCurrentPage],
    );

    // Define which filters are visible for public users (exclude availability)
    // Note: FilterSetPane checks for 'location' string, not the 'locations' property from FilterType
    const visibleFilters = ['location' as any, 'type', 'price', 'pricePerSquareMeter', 'bedbath', 'listingType', 'constructionArea', 'plotArea'];

    return (
        <>
            <div className="md:grid hidden lg:grid-cols-6 md:grid-cols-3 gap-[10px]" data-cy="filters">
                <FilterSetPane lock={true} value={currentFilter} handleChanged={handleFiltersChange} ref={filterRef} visible={visibleFilters} />
                <div className="flex gap-[10px] w-max">
                    {(getFilterCount(currentFilter) > 0 || currentFilter.query) && (
                        <div className="flex items-center gap-[5px] cursor-pointer text-my-red" onClick={onClearClicked} data-cy="clear-filter-button">
                            <div className={`rounded-full w-[25px] h-[25px] flex justify-center items-center cursor-pointer border border-my-red`}>
                                <div className="leading-[25px] text-[25px]">{'×'}</div>
                            </div>
                            <div>Clear</div>
                        </div>
                    )}
                </div>
            </div>

            <div className="md:hidden">
                <PublicMobileFilterSection />
            </div>
        </>
    );
};

export default PublicFilterPanel;
